import IpacService from './service';
import { GetIpacSpeciesResponse, UpdatedGeometry } from './types';

export class IpacQueries {
  public static readonly getSpeciesList = async (payload: UpdatedGeometry) => {
    const response: GetIpacSpeciesResponse = await IpacService.getSpeciesList(payload);

    if (response.resources) {
      const populations = Object.values(response.resources.populationsBySid);
      return populations
        .filter((pop) =>
          ['Endangered', 'Threatened', 'Proposed Endangered', 'Proposed Threatened'].includes(
            pop.population.listingStatusName
          )
        )
        .map((pop) => pop.population);
    }
    return Promise.reject('No valid species data available');
  };
}
